/** E2E chrome user email: last verified address, else the bake fallback. uid stays mock UID. */
export function e2eMockUserEmail(
  storedCreateEmail: string | null,
  fallback = 'e2e@test.com',
): string {
  const email = (storedCreateEmail || '').trim().toLowerCase();
  return email.includes('@') ? email : fallback;
}
